export default {
  name: 'FormDivider',

  props: {
    label: String,
    align: {
      type: String,
      default: 'left'
    },
    vertical: {
      type: Boolean,
      default: true
    },
    collapsible: {
      type: Boolean,
      default: false
    },
    collapsed: {
      type: Boolean,
      default: false
    }
  }
}
